import '@/App.css'
import FieldItemList from '@/resources/FieldItemList.json'
import { ChangeEvent, useState, useEffect, useMemo } from 'react'

function App() {
  // #region フック
  const [search, setSearch] = useState('')

  const [selectedItem, setselectedItem] = useState('')

  const [isDisplayCross, setIsDisplayCross] = useState<boolean>(false)

  useEffect(() => {
    const interval = setInterval(() => {
      setIsDisplayCross((previousState) => !previousState)
    }, 500)
    return () => clearInterval(interval)
  }, [])

  // #endregion フック

  // #region スタイル

  const spaceStyle: React.CSSProperties = {
    marginLeft: '10px'
  }

  const displayStyle: React.CSSProperties = {
    display: 'flex'
  }

  const selectItemStyle: React.CSSProperties = {
    width: '320px',
    height: 'calc(100vh - 210px)',
    paddingLeft: '10px',
    border: 'solid 1px',
    overflowY: 'scroll'
  }

  const ringhtSideStyle: React.CSSProperties = {
    width: 'calc(81vw - 5px)',
    height: 'calc(100vh - 210px)',
    overflowY: 'auto'
  }

  const imagesStyle: React.CSSProperties = {
    position: 'relative',
    width: 'fit-content',
    margin: '0 auto'
  }

  const overWorldStyle: React.CSSProperties = {
    width: '1120px',
    height: '700px',
    display: 'block'
  }

  const crossStyle: React.CSSProperties = {
    width: '20px',
    height: '20px',
    position: 'absolute',
    visibility: isDisplayCross ? 'visible' : 'hidden'
  }

  // #endregion スタイル

  // #region イベント

  const onChangeRadio = (e: ChangeEvent<HTMLInputElement>) => {
    setselectedItem(e.target.value)
  }

  const onChangeSearchBox = (e: ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value)
  }
  // #endregion イベント

  const toHiragana = (str: string) => {
    return str
      .normalize('NFKC') // 全角半角の揺れ対策
      .replace(/[\u30A1-\u30F6]/g, (match) => String.fromCharCode(match.charCodeAt(0) - 0x60))
  }

  const filteredOptions = useMemo(() => {
    const normalizedSearch = toHiragana(search.toLowerCase())

    return FieldItemList.fieldItems.filter((option) =>
      toHiragana(option.name.toLowerCase()).includes(normalizedSearch)
    )
  }, [search])

  return (
    <div style={spaceStyle}>
      <h1>ドラゴンクエスト9 フィールドアイテム収集用ツール</h1>
      <div style={spaceStyle}>
        左のラジオボタンから集めたいアイテムを選び、アイテムが落ちている位置を確認します。
        <br />
        テキストボックスからアイテム名の絞り込みも可能です。
        <hr />
        <div style={displayStyle}>
          <div style={selectItemStyle}>
            <input type='text' placeholder='検索...' value={search} onChange={onChangeSearchBox} />
            <br />
            {filteredOptions.map((s) => (
              <div key={s.name}>
                <input
                  type='radio'
                  id={s.name}
                  name='itemSelect'
                  value={s.name}
                  onChange={onChangeRadio}
                  checked={selectedItem === s.name}
                />
                <label htmlFor={s.name}>{s.name}</label>
              </div>
            ))}
          </div>
          <div style={ringhtSideStyle}>
            <div style={imagesStyle}>
              <img style={overWorldStyle} src={`images/overworld.jpg`} />
              {FieldItemList.fieldItems
                .find((s) => s.name === selectedItem)
                ?.coordinates.map((s, i) => (
                  <img key={i} style={{ ...crossStyle, left: s.x, top: s.y }} src={`images/cross.png`} />
                ))}
            </div>
          </div>
        </div>
        <hr />
        <a href='/tools'>ツール置き場に戻る</a>
        {'　|　'}
        <a href='/'>トップページに戻る</a>
        {'　|　'}
        <a href='/blog/hello-world'>運営者情報</a>
        {'　|　'}
        <a href='/blog/privacypolicy'>プライバシーポリシー</a>
      </div>
    </div>
  )
}

export default App
